//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isFunction } from '@/utils/validator'
import './CSearchCard.css'

export default {
  name: 'CSearchCard',

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },

    searchCardFormat: {
      type: [
        Array,
        Function,
      ],
      default: () => {
        return [
          {
            label: '中学名称',
            value: 'name',
            none: true,
          },
          {
            label: '地区',
            value: 'sydqWidDisplayValue',
          },
        ]
      },
    },

    value: {
      type: [
        String,
        Number,
      ],
      default: '',
    },

    valueName: {
      type: String,
      default: 'key',
    },

  },

  computed: {
    radioActiveClass () {
      return this.item[this.valueName] === this.value ? 'active radio-active' : ''
    },

    innerSearchCardFormat () {
      if (isFunction(this.searchCardFormat)) {
        return this.searchCardFormat(this.item)
      } else {
        return this.searchCardFormat
      }
    },
  },
}
